var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('UiTabs',[_c('UiTab',{attrs:{"to":"/about"}},[_vm._v("About")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }